import { render } from "./RefBody.vue?vue&type=template&id=5cd1c3a2&scoped=true"
import script from "./RefBody.vue?vue&type=script&lang=js"
export * from "./RefBody.vue?vue&type=script&lang=js"

import "./RefBody.vue?vue&type=style&index=0&id=5cd1c3a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd1c3a2"]])

export default __exports__